<template>
  <div
    id="sidebar-container"
    class="
      sideBar
      d-flex
      flex-column
      justify-content-center
      align-items-center
      h-100
      pt-5
    "
  >
    <div v-if="!isInIframe" class="d-flex">
      <div v-if="showSideBar">
        <img
          id="logo"
          src="@/assets/images/svg/logo.svg"
          class="full-logo cp"
          alt="lune-logo"
          @click="$router.push({ name: 'Overview' })"
        />
      </div>

      <div
        class="side-bar-toggle cp pb-5 px-4 ms-1"
        :class="{ show: showSideBar }"
        @click="toggleSideBar"
      >
        <img
          src="../assets/images/svg/new_sidebar/Expand.svg"
          alt="sideBar-btn"
        />
      </div>
    </div>

    <div
      class="
        w-100
        flex-grow-1
        d-flex
        flex-column
        justify-content-start
        align-items-stretch
      "
    >
      <div
        v-for="(routeGroup, groupIndex) in routeList"
        :key="routeGroup.id"
        class="
          w-100
          d-flex
          flex-column
          justify-content-start
          align-items-stretch
        "
      >
        <SideBarLink
          v-for="route in routeGroup.children"
          :key="route.id"
          :route="route"
          :show-side-bar="showSideBar"
        />

        <div
          v-if="groupIndex < routeList.length - 1"
          class="h-line"
          :class="{ show: showSideBar }"
        ></div>
      </div>
      <div
        v-if="!isInIframe"
        class="pb-2 flex-grow-1 d-flex flex-column justify-content-end"
      >
        <LogOutRouteButton :show-side-bar="showSideBar" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { routes } from "../data/options";
import SideBarLink from "../components/SideBarLink.vue";
import LogOutRouteButton from "./LogOutRouteButton.vue";
import { useIsInIframe } from "@/composables/useIsInIframe";
import store from "@/store";

const showSideBar = ref(false);
const isInIframe = useIsInIframe();

const routeList = computed(() => {
  const iframeHiddenRoutes = ["misc", "documentation"];

  const traverseRoutes = (routesObj = {}) => {
    const routeList = Object.values(routesObj);
    if (routeList.length === 0) return [];
    return routeList
      .filter((route) => !iframeHiddenRoutes.includes(route.id))
      .map((route) => ({ ...route, children: traverseRoutes(route.children) }));
  };
  return traverseRoutes(routes);
});

const toggleSideBar = () => {
  showSideBar.value = !showSideBar.value;
  store.commit("updateShowSideBar", showSideBar.value);

  const sidebarContainer = document.getElementById("sidebar-container");
  if (showSideBar.value) {
    sidebarContainer.style.width = "225px";
  } else {
    sidebarContainer.style.width = "85px";
  }
};
</script>

<style scoped>
.sideBar {
  width: 85px;
  /* border-right: 2px solid green; */
  background-color: white;
  transition: all 0.2s ease-in-out;
  box-shadow: 0px 4px 40px 0px rgba(204, 213, 212, 0.4);
  border-radius: 0px 30px 30px 0px;
  overflow-y: auto;
  overflow-x: hidden;
}
.side-link-icon {
  width: 38px !important;
}
.side-bar-toggle img {
  width: 18px;
  transition: var(--d-ease);
}
.side-bar-toggle.show img {
  transform: rotate(-180deg);
}
.h-line {
  height: 2px;
  background-color: #e6eaea;
  border-radius: 20px;
  margin: 0.35rem 1.5rem;
}
.h-line.show {
  margin: 0.35rem 1.3rem;
}
.full-logo {
  width: 9rem;
}
</style>
